<div class="mt-3 border border-dark pt-3 ps-3 pe-3 pb-3">
    <h5 class="border-bottom border-secondary pb-2 mb-0">
        {{ "turnList" | language }}
        <i (click)="getTurnList()" id="refreshList" class="fa fa-refresh float-end" aria-hidden="true" [title]="'refresh' | language"></i>
    </h5>
    <p *ngIf="selectedQueue==null" class="mt-3">{{ "selectQueueToWork" | language }}:</p>
    <select class="form-select mt-3" *ngIf="_data.configuration['activeSupervisor'] || _data.session['schemaitms'].split(',').length > 1" [(ngModel)]="selectedQueue" (change)="getTurnList()" (ngModelChange)="clearResetIntervals($event)">
    <option *ngIf="queuesnotempty.length > 0" value="all">{{ "allqueues" | language }}</option>
    <option *ngFor="let q of queuesnotempty" [value]="q.id">{{ q.title }}</option>
  </select>
    <div *ngIf="selectedQueue!=null">
        <div class="mb-3">
            <div class="bg-light w-100 mt-2 p-1 rounded-top text-center">
                <div style="width: 1100px; margin: auto;">
                    <label>{{ "filter" | language }}:</label>
                    <input class="form-control form-control-sm d-inline-block me-2 ms-2 w-25" type="text" (change)="searchFilter()" (keyup)="searchFilter()" [(ngModel)]="search" [placeholder]="'search' | language">
                    <button (click)="removeSearch()" class="btn btn-light btn-sm d-inline-block">{{ "clearFilters" | language }}</button>
                </div>
            </div>
            <div class="mt-2 mb-2 d-flex align-items-center">
              <div class="d-flex align-items-center" style="overflow-x:auto; white-space:nowrap;">
                <span class="badge" [ngClass]="!options['noShow'] ? 'text-dark' : 'text-white'" [ngStyle]="{'background-color': (options['noShow']) ?  _data.configuration['noShow'] : 'inherit' }">
                  <input (change)="saveOptions()" [(ngModel)]="options['noShow']" type="checkbox">
                  {{ "noShow" | language }}
                </span>
                <span class="badge" [ngClass]="!options['inWait'] ? 'text-dark' : 'text-white'" [ngStyle]="{'background-color': (options['inWait']) ? _data.configuration['inWait'] : 'inherit' }">
                  <input (change)="saveOptions()" [(ngModel)]="options['inWait']" type="checkbox">
                  {{ "inWait" | language }}
                </span>
                <span class="badge" [ngClass]="!options['redirect'] ? 'text-dark' : 'text-white'" [ngStyle]="{'background-color': (options['redirect']) ? _data.configuration['redirect'] : 'inherit' }">
                  <input (change)="saveOptions()" [(ngModel)]="options['redirect']" type="checkbox">
                  {{ "redirected" | language }}
                </span>
                <span class="badge" [ngClass]="!options['finished'] ? 'text-dark' : 'text-white'" [ngStyle]="{'background-color': (options['finished']) ? _data.configuration['finished'] : 'inherit' }">
                  <input (change)="saveOptions()" [(ngModel)]="options['finished']" type="checkbox"> {{ "finished" | language }}
                </span>
                <span class="badge" [ngClass]="!options['inAttention'] ? 'text-dark' : 'text-white'" [ngStyle]="{'background-color': (options['inAttention']) ? _data.configuration['inAttention'] : 'inherit'}">
                  <input (change)="saveOptions()" [(ngModel)]="options['inAttention']" type="checkbox">
                  {{ "inAttention" | language }}
                </span>
                <span class="badge" [ngClass]="!options['cancelled'] ? 'text-dark' : 'text-white'" [ngStyle]="{'background-color': (options['cancelled'] && _data.configuration['cancelled']) ? _data.configuration['cancelled'] : options['cancelled'] ? '#BCD6B8' : 'inherit'}">
                  <input (change)="saveOptions()" [(ngModel)]="options['cancelled']" type="checkbox">
                  {{ "cancelled" | language }}
                </span>
            </div>
            <div class="dropdown ms-auto">
              <button class="btn btn-sm btn-light dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-table" aria-hidden="true"></i> {{ 'columnFilter' | language }}
              </button>
              <button class="btn btn-sm btn-light" [title]="'resetFilter' | language" (click)="resetColumns()">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <div [sortablejs]="columns" [sortablejsOptions]="sortableOptions">
                      <div class="dropdown-item" *ngFor="let c of columns; let i = index">
                          <input type="checkbox" [id]="columns[i].name" [(ngModel)]="columns[i].visible" (change)="saveColumns()">
                          <label [for]="columns[i].name">{{ c.lang | language }}</label>
                          <i class="fa fa-sort order-icon" aria-hidden="true"></i>
                      </div>
                  </div>
              </div>
            </div>
            </div>
            <table class="table my-colored-table table-bordered sortable animated fadeIn">
                <thead>
                    <tr>
                        <th></th>
                        <ng-container *ngFor="let c of columns">
                            <th *ngIf="(c.visible && c.name != 'queuename') || (c.visible && c.name == 'queuename' && selectedQueue == 'all')" (click)="orderBy(c.name)" [ngClass]="{'bold' : orderType == c.name}">
                                {{ c.lang | language }}
                                <i *ngIf="orderType == c.name && !orderReverse" class="fa fa-caret-up" aria-hidden="true"></i>
                                <i *ngIf="orderType == c.name && orderReverse" class="fa fa-caret-down" aria-hidden="true"></i>
                            </th>
                        </ng-container>
                    </tr>
                </thead>

                <tbody>
                    <tr
                      (click)="selectTurn(t); selected = i"
                      *ngFor="let t of _blogic.turns | orderBy:orderType : orderReverse : false | filterBy: listFilter; let i = index"
                      style="font-weight:bold; cursor:pointer;"
                      [style.background]="computeRowBg(t, i)"
                      [style.color]="computeRowColor(t, i)"
                    >
                      <ng-container *ngIf="columnLoaded">
                          <ng-container *ngIf="(isNoShow(t) || isInWait(t) || isRedirect(t) || isInWait(t) || isFinished(t) || isInAttention(t) || isCancelled(t))">
                              <td *ngIf="selected != i" class="text-dark">
                                  <i (click)="history.openHistoryModal(t, 'listHistory')" class="fa fa-info-circle" aria-hidden="true"></i>
                                  <i *ngIf="_data.configuration['canPrintTicket'] && isNoShow(t) && (printed || tprinting != t.id)" (click)="printTicket(t.id)" class="fa fa-print" aria-hidden="true"></i>
                                  <i *ngIf="!printed && tprinting == t.id" class="fa fa-spinner fa-spin fa-fw cente" aria-hidden="true"></i>
                              </td>
                              <td *ngIf="selected == i" class="text-white">
                                  <i (click)="history.openHistoryModal(t, 'listHistory')" class="fa fa-info-circle" aria-hidden="true"></i>
                                  <i *ngIf="_data.configuration['canPrintTicket'] && isNoShow(t) && (printed || tprinting != t.id)" (click)="printTicket(t.id)" class="fa fa-print" aria-hidden="true"></i>
                                  <i *ngIf="!printed && tprinting == t.id" class="fa fa-spinner fa-spin fa-fw cente" aria-hidden="true"></i>
                              </td>
                          </ng-container>
                          <ng-container *ngFor="let c of columns">
                              <ng-container *ngIf="(isNoShow(t) || isInWait(t) || isRedirect(t) || isInWait(t) || isFinished(t) || isInAttention(t) || isCancelled(t)) && visibleColumns.indexOf(c.name)!==-1">
                                  <!-- Columnas con información común -->
                                  <td *ngIf="c.name == 'plandate' ||
                                      c.name == 'planhour' ||
                                      c.name == 'clientid' ||
                                      c.name == 'ccode' ||
                                      c.name == 'clientname' ||
                                      c.name == 'prekindname' ||
                                      c.name == 'task'  ||
                                      c.name == 'initdatetime' ||
                                      c.name == 'lastredirect' ||
                                      c.name == 'deskdatetime' ||
                                      c.name == 'rdcomment' ||
                                      c.name == 'attime' ||
                                      c.name == 'waittime'
                                      ">
                                      <span *ngIf="c.name != 'plandate' && c.name != 'initdatetime' && c.name != 'deskdatetime' && c.name != 'lastredirect' && c.name != 'rdcomment'">{{ t[c.name] }}</span>
                                      <span *ngIf="c.name == 'plandate'">{{ t[c.name] | date: 'dd-MM-yyyy' }}</span>

                                      <span *ngIf="c.name == 'rdcomment'" [innerHTML]="t[c.name]"></span>
                                      <span *ngIf="c.name == 'initdatetime'">{{ t[c.name] | date: 'HH:mm' }}</span>
                                      <span *ngIf="c.name == 'lastredirect' && t['lastredirect'] != null && !isFinished(t) && !isRedirect(t) && !isInAttention(t)">{{ t['lastredirect'] }}</span>
                                      <span *ngIf="c.name == 'lastredirect' && t['lastredirect'] == null && !isFinished(t) && !isRedirect(t) && !isInAttention(t)">{{  t['lastredirect'] }}</span>
                                      <span *ngIf="c.name == 'lastredirect' && isFinished(t) && isRedirect(t) && isInAttention(t)"></span>
                                      <span *ngIf="c.name == 'deskdatetime'">{{ t[c.name] | date: 'HH:mm' }}</span>
                                  </td>

                                  <td *ngIf="c.name == 'queuename' && selectedQueue == 'all'"><span>{{ t.queuename }}</span></td>
                                  <!-- Columnas especiales -->
                                  <td *ngIf="c.name == 'type' && isNoShow(t)">{{ "noShow" | language }}</td>
                                  <td *ngIf="c.name == 'type' && isInWait(t)">{{ "inWait" | language }}</td>
                                  <td *ngIf="c.name == 'type' && isRedirect(t)">{{ "redirected" | language }}</td>
                                  <td *ngIf="c.name == 'type' && isFinished(t)">{{ "finished" | language }}</td>
                                  <td *ngIf="c.name == 'type' && isCancelled(t)">{{ "cancelled" | language }}</td>
                                  <td *ngIf="c.name == 'type' && isInAttention(t)">{{ "inAttention" | language }}</td>
                                  <td *ngIf="c.name == 'label'">
                                      <span *ngIf="t.lastredirect != null && t.queue_id == selectedQueue && !isFinished(t) && t.lqueue_id != '-1' && !isInAttention(t)" [style.color]="_data.configuration['redirect']">({{ "redirected" | language }})</span>                                        {{ t.label }}</td>
                                  <td *ngIf="c.name == 'deskname'">
                                      <span *ngIf="t.desk_id != -1">#{{ t.desk_id }} - {{ t.deskname }}</span>
                                  </td>
                              </ng-container>
                          </ng-container>
                      </ng-container>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<app-history [id]="'listHistory'"></app-history>

<app-modal [id]="'filterModal'">
    <span modal-title>{{ "moreFilters" | language }}</span>
    <div modal-body>
        <form class="row" name="filtersForm" (ngSubmit)="applyFilters($event)">
            <div class="mb-3 col-md-6">
                <label for="clientname">{{ "client" | language }}</label>
                <input type="text" class="form-control" [value]="filters['clientname']" name="clientname" id="clientname">
            </div>
            <div class="mb-3 col-md-6">
                <label for="clientid">{{ "cclient" | language }}</label>
                <input type="text" class="form-control" [value]="filters['clientid']" name="clientid" id="clientid">
            </div>
            <div class="mb-3 col-md-6">
                <label for="label">{{ "turn" | language }}</label>
                <input type="text" class="form-control" [value]="filters['label']" name="label" id="label" placeholder="A001">
            </div>
            <div class="mb-3 col-md-6">
                <label for="planhour">{{ "hour" | language }}</label>
                <input type="time" class="form-control" [value]="filters['planhour']" name="planhour" id="planhour">
            </div>
            <div class="mb-3 col-md-12">
                <label for="prekind_id">{{ "actualKind" | language }}</label>
                <select id="prekind_id" class="form-select" [value]="filters['prekind_id']" name="prekind_id">
          <option value="" checked>Todos</option>
          <option *ngFor="let a of _data.session['atypes']" [value]="a.id">{{ a.name }}</option>
        </select>
            </div>
            <div class="mb-3 col-md-12">
                <label for="desk_id">{{ "desk" | language }}</label>
                <select id="desk_id" class="form-select" [value]="filters['desk_id']" name="desk_id">
          <option value="" checked>Todos</option>
          <option *ngFor="let d of _data.desks" [value]="d.id">#{{ d.id }} - {{ d.title }}</option>
        </select>
            </div>
            <div class="col-md-12">
                <button type="submit" class="btn btn-primary me-2"><i class="fa fa-filter" aria-hidden="true"></i>
          {{ "accept" | language }}</button>
                <button type="reset" class="btn btn-light" (click)="clearFilters()"><i class="fa fa-trash"
            aria-hidden="true"></i> {{ "clearFilters" | language }}</button>
            </div>
        </form>
    </div>
</app-modal>
